import { createSlice } from '@reduxjs/toolkit'
import API, { API_VERSION, REQUEST_METHOD } from '../../../api'
import { createTrackedAsyncThunk } from '../../../pages/feeManagement/utils/reduxHelpers'

export const initialState = {
  overrides: {
    data: null,
    isLoading: false,
    error: null,
  },
}

export const fetchLoanOverrides = createTrackedAsyncThunk(
  'loanOverrides/fetchLoanOverrides',
  async (params, { rejectWithValue }) => {
    try {
      const { loanId, productIds, dataTypes, panelistId } = params
      const requestBody = {
        product_ids: productIds,
        data_types: dataTypes,
        should_fetch_legacy_overrides: true,
        panelist_id: panelistId || null,
      }

      const response = await API(`loans/${loanId}/overrides`, API_VERSION.TWO).request(
        REQUEST_METHOD.POST,
        {},
        requestBody,
      )

      return response
    } catch (err) {
      return rejectWithValue(err.errors?._error || 'Failed to fetch loan overrides')
    }
  },
  { errorSource: 'loanOverrides.overrides' },
)

const loanOverridesSlice = createSlice({
  name: 'loanOverrides',
  initialState,
  reducers: {
    resetLoanOverrides: (state) => {
      state.overrides = {
        data: null,
        isLoading: false,
        error: null,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanOverrides.pending, (state) => {
        state.overrides.isLoading = true
        state.overrides.error = null
      })
      .addCase(fetchLoanOverrides.fulfilled, (state, action) => {
        state.overrides.isLoading = false
        state.overrides.data = action.payload
        state.overrides.error = null
      })
      .addCase(fetchLoanOverrides.rejected, (state, action) => {
        state.overrides.isLoading = false
        state.overrides.error = action.payload
      })
  },
})

export const { resetLoanOverrides } = loanOverridesSlice.actions

export default loanOverridesSlice.reducer
